import React from 'react';
import links from './Links';
import './Header.css';

const Header = () => {
  return (
    <header className="App-header">
      <div className="logo-container">
        <img src="/logoBlue.png" alt="Logo" className="logo" />
      </div>
      <nav>
        <ul>
          {links.map((link, index) => (
            <li key={index}>
              <a href={link.url}>{link.name}</a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
